import { environment } from "src/configs/constance";
import ABI from "src/contract-logic/abis/Bridge/MainCanonicalABI.json";
import { NETWORKS } from "src/configs/connection-config";
import Web3 from "web3";
import { getCurrentContractAddresses } from "../../../configs/address";
import { getWeb3Sender } from "../../../wallet-connection";

const { SIDE_CANONICAL_TRANSACTION_CHAIN } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    const web3Reader =
      environment == "mainnet" ? new Web3(NETWORKS.ETH_MAINNET.rpcUrls[0]) : new Web3(NETWORKS.SEPOLIA.rpcUrls[0]);
    contractReader = new web3Reader.eth.Contract(ABI, SIDE_CANONICAL_TRANSACTION_CHAIN);
  }
  if (!contractReader) {
    throw new Error("Failed to create sidecanonical contract reader");
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, SIDE_CANONICAL_TRANSACTION_CHAIN);
  }
  if (!contractSender) {
    throw new Error("Failed to create rent contract sender");
  }
  return contractSender;
}

async function getQueueLength() {
  const res = await getContractReader().methods.getQueueLength().call();
  return parseInt(res);
}

export default {
  ABI,
  ADDRESS: SIDE_CANONICAL_TRANSACTION_CHAIN,
  getContractSender,
  getQueueLength,
};
